import type { IMarketData } from "@stepfinance/common";
import { useEffect, useState } from "react";
import useSWRImmutable from "swr/immutable";

import { useNetworkConfig } from "../../contexts/app/config";
import { STEP_API_ENDPOINT, swrFetcher } from "../../utils/swr";

type TokenSymbol = string;
type TokenMintAddress = string;
export type MarketDataMap = Map<TokenSymbol | TokenMintAddress, IMarketData>;

export const useMarketDataMap = () => {
  const { network } = useNetworkConfig();
  const [marketDataMap, setMarketDataMap] = useState<MarketDataMap>(new Map());
  const { data, mutate: refresh } = useSWRImmutable<MarketDataMap>(
    // TODO: Use formatNetwork helper in solana-contrib (needs to be updated first)
    `${STEP_API_ENDPOINT}/v2/markets/prices?cluster=${network}`,
    swrFetcher,
  );

  // Use without check since data potentially undefined
  useEffect(() => {
    if (data) {
      const marketMap = new Map(Object.entries(data));
      setMarketDataMap(marketMap);
    }
  }, [data]);

  return {
    marketDataMap,
    refresh,
  };
};
